import { Grid, Skeleton } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import React from 'react'

export const Placeholder = ({ className = '' }) => (
  <Skeleton
    shown
    className={className}
  >
    <Grid
      wrap={false}
      gap={9}
      className={'margin-bottom-24'}
    >
      <Skeleton.Item
        height={30}
        width={'100%'}
      />
      <Skeleton.Item
        height={30}
        width={'100%'}
      />
    </Grid>
    <Grid justifyContent={'center'}>
      <Skeleton.Item
        width={116}
        height={116}
        style={{ borderRadius: '50%' }}
      />
    </Grid>
  </Skeleton>
)

Placeholder.propTypes = {
  className: PropTypes.string,
}
